import { getGroupsStore } from 'owa-groups-shared-store/lib/GroupsStore';

export function getGroupDisplayName(groupId: string): string {
    if (!groupId) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (8,9): Type 'null' is not assignable to type 'string'.
        // @ts-expect-error
        return null;
    }

    const groupsStore = getGroupsStore();
    const group = groupsStore.groups.get(groupId.toLowerCase());
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (16,5): Type 'string | undefined' is not assignable to type 'string'.
    // @ts-expect-error
    return group?.basicInformation ? group.basicInformation.DisplayName : groupId;
}
